import React from 'react';
import { Home, Gamepad2, Search, User, Sparkles, Sun, Moon } from 'lucide-react';
import { useTheme } from '@/hooks';
import { useSiteSettings } from '@/contexts/settings-context';
import styles from './sidebar.module.css';

interface NavItem {
  icon: React.ReactNode;
  label: string;
  href: string;
}

interface SidebarProps {
  activePath?: string;
}

export const Sidebar: React.FC<SidebarProps> = ({ activePath = '/' }) => {
  const { theme, toggleTheme } = useTheme();
  const { site, features } = useSiteSettings();

  const navItems: NavItem[] = [
    { icon: <Home size={20} />, label: '首页', href: '/' },
    { icon: <Gamepad2 size={20} />, label: '全部游戏', href: '/games' },
    ...(features.search ? [{ icon: <Search size={20} />, label: '搜索', href: '/search' }] : []),
    { icon: <User size={20} />, label: '个人中心', href: '/profile' },
  ];

  return (
    <aside className={styles.sidebar}>
      <div className={styles.logo}>
        <div className={styles.logoIcon}>
          {site.logo ? (
            <img src={site.logo} alt={site.title} className={styles.logoImg} />
          ) : (
            <Sparkles size={24} />
          )}
        </div>
        <span className={styles.logoText}>{site.title}</span>
      </div>

      <nav className={styles.nav}>
        {navItems.map((item) => {
          const isActive = activePath === item.href || 
            (item.href !== '/' && activePath.startsWith(item.href));
          
          return (
            <a
              key={item.href}
              href={item.href}
              className={`${styles.navItem} ${isActive ? styles.active : ''}`}
            >
              <span className={styles.navIcon}>{item.icon}</span>
              <span className={styles.navLabel}>{item.label}</span>
              {isActive && <div className={styles.activeIndicator} />}
            </a>
          );
        })}
      </nav>

      <div className={styles.footer}>
        {features.darkMode && (
          <button className={styles.themeToggle} onClick={toggleTheme} title={theme === 'dark' ? '切换亮色模式' : '切换暗色模式'}>
            {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
            <span>{theme === 'dark' ? '亮色模式' : '暗色模式'}</span>
          </button>
        )}
        <p className={styles.copyright}>© {new Date().getFullYear()} {site.title}{site.icp ? ' · ' : ''}{site.icp ? <span dangerouslySetInnerHTML={{ __html: site.icp }} /> : ''}</p>
      </div>
    </aside>
  );
};

export default Sidebar;
